import { Injectable, inject } from '@angular/core';
import { ToastController, ToastOptions } from '@ionic/angular';

export const DURATION_DATA_REVIEW_ERROR = 7000; // Displays more text in toast message -> better to read
const DEFAULT_DURATION = 2500;

const DEFAULT_TOAST_OPTIONS: ToastOptions = {
  buttons: [
    {
      icon: 'close-outline',
      role: 'cancel',
      side: 'end',
    },
  ],
  color: 'success',
  cssClass: 'proto-toast',
  duration: DEFAULT_DURATION,
  position: 'top', // set duration to 0 if toast should not disappear automatically
};

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private toastElement: HTMLIonToastElement;

  private toastController = inject(ToastController);

  public async show(message: string, options: ToastOptions = DEFAULT_TOAST_OPTIONS): Promise<void> {
    // prevent multiple toasts with same message
    if (this.toastElement?.message === message) {
      return Promise.resolve();
    }

    const toastOptions: ToastOptions = {
      ...DEFAULT_TOAST_OPTIONS,
      ...options || {},
    };

    toastOptions.message = message;

    this.toastElement = await this.toastController.create(toastOptions);

    await this.toastElement.present();

    this.toastElement?.onDidDismiss().then(() => {
      this.toastElement = null;
    })
      .catch();

    return Promise.resolve();
  }

  public hide(): void {
    if (this.toastElement) {
      return;
    }

    this.toastElement.dismiss().catch();
  }
}
